import React from 'react';
import { KeyboardDatePicker, KeyboardDatePickerProps } from '@material-ui/pickers';
import { FieldProps } from 'formik';

export interface FormikDatePickerProps
    extends FieldProps,
        Omit<KeyboardDatePickerProps, 'value' | 'onChange'> {}

export const FormikDatePicker = ({ meta, ...props }: FormikDatePickerProps) => {
    const showError = meta.touched && meta.error;
    return (
        <KeyboardDatePicker
            disableToolbar
            autoOk
            fullWidth
            variant="inline"
            format={'dd.MM.yyyy'}
            label={props.label}
            value={props.field.value}
            error={!!showError}
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
            style={{ marginRight: '24px' }}
            onChange={(val) => props.form.setFieldValue(props.field.name, val || null, true)}
            helperText={meta.error}
            {...props}
        />
    );
};

export default FormikDatePicker;
